// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__2FYCU","left":"StickyBox_left__2s7Hx","right":"StickyBox_right__3r-Nu"};